import {useContext} from "react";
import { dataContext } from "../../context/context";
import { motion, AnimatePresence } from "framer-motion";
import Feedback from "../feedback/feedback";
import "./modal.css"


function Modal() {

    const { isModal, setModal  } = useContext(dataContext);



    return (

         <AnimatePresence>
             { isModal && (
          <>
            <motion.div key="1000" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }} exit={{ opacity: 0 }} className="background_modal" onClick={() => setModal(false)}></motion.div>

            <motion.div key="1001"  initial={{ x: "-200%", y: "-50%", opacity: 0 }} animate={{ x: "-50%", y: "-50%", opacity: 1 }} transition={{ duration: 0.25 }} exit={{ x: "200%", y: "-50%", opacity: 0 }} className="modal">
            <a className="close" onClick={() => setModal(false)}>&#61453;</a>
            <Feedback />
        </motion.div>
            </>
        )}
         </AnimatePresence>

    )


}

export default Modal;